@import "~@govbr-ds/core/src/components/item/item";

:host {
  display: block;
}

::slotted(br-checkbox) {
  max-width: fit-content;
  max-height: fit-content;
}

::slotted(br-radio) {
  max-width: fit-content;
  max-height: fit-content;
}

.br-item:focus {
  cursor: auto;
  outline: var(--focus) var(--focus-style) var(--focus-width);
  outline-offset: var(--focus-offset);
}

.no-text-selection {
  user-select: none;
}
